import React from 'react'
import MaterialSymbol from '../material-symbol'

const EventBusy = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="event_busy" {...props} />
))

EventBusy.displayName = 'EventBusy'

export default EventBusy
